import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { FileSystemClientBase } from './FileSystemClientBase';
import { getFileSystem, updateFileSystem } from './generated/FileSystemClient/fileSystemHttpRequests';
export class FileSystemClient extends HttpBaseClient(FileSystemClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getFileSystemImpl", getFileSystem);
    _defineProperty(this, "updateFileSystemImpl", updateFileSystem);
  }
}
//# sourceMappingURL=FileSystemClientHttp.js.map